import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { pipe } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ForbiddenNavigationService {
  public forbiddenUrl: string | null;

  constructor(private router: Router) {
    this.trackForbiddenRoute();
  }

  /**
   * If the user navigates to a forbidden route, we want to track the original
   * route that was forbidden so we can show that URL in the `forbidden` UI component.
   * @param router
   */
  private trackForbiddenRoute() {
    const onlyNavigationEnd = pipe(
      filter((event) => event instanceof NavigationEnd)
    );
    this.router.events.pipe(onlyNavigationEnd).subscribe((e: NavigationEnd) => {
      const { url, urlAfterRedirects } = e;
      const isRedirecting = url !== urlAfterRedirects;
      const isForbidden = urlAfterRedirects.indexOf('forbidden') > 0;

      this.forbiddenUrl = isRedirecting && isForbidden ? url : null;
    });
  }
}
